import { ContentImage } from "@hub/models/ui/content-image";
import styles from "@hub/ui/cards/document-card.module.css";
import Image from "next/image";
import React from "react";

export const DocumentCardIcon: React.FC<ContentImage> = ({ src, alt }) => {
  return (
    <div className={styles.icon__tile}>
      <div className={styles.icon__logo}>
        <Image src={src} alt={alt} layout="fill" />
      </div>
    </div>
  );
};
